import { formatDateTime } from "../format"
import { TextCell } from "./text-cell"

type Props = {
  value: string | null | undefined
  align?: "left" | "right" | "center"
}

export function DateTimeCell({ value, align = "left" }: Props) {
  return <TextCell value={formatDateTime(value)} align={align} />
}
